import { createContext, useContext } from 'react';
import { useAuth } from './AuthContext';
import { useAlarmBadgeCount } from '../hooks/useAlarmBadgeCount';

const AlarmBadgeContext = createContext(0);

export function AlarmBadgeProvider({ children }) {
  const { user } = useAuth();
  const enabled = !!user;
  const count = useAlarmBadgeCount(enabled);
  return <AlarmBadgeContext.Provider value={count}>{children}</AlarmBadgeContext.Provider>;
}

export function useAlarmBadge() {
  return useContext(AlarmBadgeContext);
}
